module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMallList zdy-groupList"
  }, [_c('x-header', {
    staticClass: "intallMallHead"
  }, [_vm._v("充值礼品卡")]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false,
      "show-vertical-dividers": false,
      "cols": 2
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('grid-item', {
      key: index,
      on: {
        "on-item-click": function($event) {
          _vm.ListClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "slot": "icon",
        "src": item.img
      },
      slot: "icon"
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b8f7036","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallListOne.vue
// module id = SvoL
// module chunks = 7